import { gql } from 'graphql-request'
import { MutationDataError } from '@/resources/types'
import { useMutation, UseMutationResult } from '@/proxy/react-query'
import { UseRestoreOriginalOrder } from './types'
import { client } from '@/proxy/client'

export const RESTORE_ORIGINAL_ORDER = gql`
  mutation restoreOriginalOrder($orderNumber: String!) {
    restoreOriginalOrder(orderNumber: $orderNumber) {
      items {
        variantId
        name
        amount
        unitPrice
        totalPrice
        image
        categoryId
        brandId
      }
      charging {
        shippingFee
        subTotal
        discount
        cashback
        change
        total
        totalSamplingsPrice
      }
      pickupCode
    }
  }
`

export const useRestoreOriginalOrder = (): UseMutationResult<
  UseRestoreOriginalOrder,
  MutationDataError,
  { orderNumber: string }
> =>
  useMutation({
    mutationFn: (variables: { orderNumber: string }) =>
      client.request(RESTORE_ORIGINAL_ORDER, variables),
  })
